module.exports = __webpack_public_path__ + "static/media/lock-open.c4f23f6c.svg";